import React, { FC } from 'react';
import SolutionCard from 'containers/about-us/SolutionCard';
import holistic from 'assets/about-us/holistic.png';
import exclusive from 'assets/about-us/exclusive.png';
import custom from 'assets/about-us/custom.png';
import operation from 'assets/about-us/operation.png';
import HorizontalLine from 'evcharging/components/HorizontalLine';
import Spacer from 'evcharging/components/Spacer';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import useI18n from 'evcharging/hooks/useI18n';
import { HOME_LINK } from 'evcharging/app/seo/pages';
import { RETAIL_URL } from 'config/seo/urls';
import Mobile from "../../evcharging/components/Mobile";

interface SolutionsProps {
  index: number
}

const Solutions: FC<SolutionsProps> = (props) => {
  const {index} = props;
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  const items = [
    [
      {
        image: custom,
        title: 'Customized Business Solutions',
        text: <>
          Catering to the unique energy demands of businesses. Optimal, efficient, and reliable.
        </>,
        label: 'Inquire About Business Options',
        href: HOME_LINK,
      },
      {
        image: operation,
        title: 'Operational Savings',
        text: <>
          Integrating smarter energy choices, ensuring you save more on every front.
        </>,
        label: 'Discover Business Savings',
        href: RETAIL_URL,
      }
    ]
  ];
  return (
    <section className={styles.root}>
      <div className={styles.cardColumn}>
        <SolutionCard {...items[index][0]} />
        <Mobile>
          <Spacer value={40} />
        </Mobile>
        <SolutionCard {...items[index][1]} />
      </div>
      <Spacer value={24} />
    </section>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    padding: 0 0 0 32px;
    ${theme.breakpoints.mobile.down} {
      padding: 24px 12px;
    }
      height: 100%; 
  `,
  cardColumn: css`
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%; 
      
      min-height: 400px; 
  `,
});

export default Solutions;
